export default __webpack_public_path__ + "static/media/logo_arkid.6aef678e.svg";